export default {"src":"/_next/static/media/icon_3dmodel_hovered.e596674c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};